import React from "react";
// import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import classNames from "classnames";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CustomInput from "components/CustomInput/CustomInput.jsx";

import {
  Grid,
  FormControl,
  InputLabel
} from "@material-ui/core";

import Button from "components/CustomButtons/Button.jsx";
import InlineDatePicker from "../../utils/InlineDatePicker"
import { appConstants } from "../../_constants";
import AutocompleteSelect from "../../utils/AutocompleteSelect";


const styles = theme => ({
  container: {
    display: "flex",
    flexWrap: "wrap"
  },
  input: {
    marginTop: "0 !important"
  },
  nb: {
    color: "red",
    fontSize: "12px"
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: "67%"
  },
  root: {
    flexGrow: 1
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: "center",
    color: theme.palette.text.secondary
  },
  formRoot: {
    display: "flex",
    flexWrap: "wrap"
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    width: "100%"
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2
  },
  searchButton: {
    backgroundColor: " #66bb6a"
  },
  airlineSelect: {
    marginTop: "0px",
    width: '100%'
  },
  note:{
    color: "#FF0000",
    fontSize: "12px",
    textAlign:"center",
    marginLeft:"20px"  }
});

function ReconciliationPanel(props) {
  const { classes, data, startDate, endDate, handleDateChange,
    onSearch, startLabel, endLabel, handleOpenModal, handleClose, handleSubmit,
    isOpen, handleChange, error, formError, reconciliationTypes, reactSelectChange,
    statusTypes,  requesting, airlineError, currency,
    narrationError, tokenError, typeError, airports, airportError,
    user, selectChange, newAirlineId, newAirportCode, currencyOptions,
  airportCode, AirlineId} = props;

  return (
    <div className={classes.root}>
      <Grid container spacing={24}>
        <Grid item md={12} xs={12}>
          <Button style={{
            float: "right",
            marginBottom: "30px"
          }}
            color={"regional"}
            onClick={handleOpenModal}
          >
            Add Reconciliation
          </Button>
        </Grid>

      </Grid>

      {/* Add Reconciliation Modal */}
      <Dialog
        // fullScreen={fullScreen}
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title" style={{ background: `linear-gradient(60deg, ${appConstants.REGIONAL_LIGHT_COLOR}, ${appConstants.REGIONAL_COLOR})`}}>
          <span style={{ color: "white", textTransform: "uppercase" }}> Add Reconciliation</span>
        </DialogTitle>
        <DialogContent style={{ marginTop: "20px" }}>
          <Grid container spacing={24}>
          <p className={classes.note}>Reconciliation created in naira will not be converted to dollar!</p>
            <Grid item md={12} xs={12}>

              {error && <span style={{ color: 'red' }}>{formError}</span>}

              <FormControl className={classNames(classes.airlineSelect, classes.formControl)}>
                <InputLabel shrink htmlFor="airlineId">Airline</InputLabel>
                <AutocompleteSelect
                    options={data.map(option => ({ value: option.AirlineId, label: option.Airline }))}
                    handleSelectChange={(e, name) => selectChange(e, name)}
                    disabled={user.AppRole === appConstants.ROLES.AIRLINE}
                    name={"newAirlineId"}
                    selectedOption={newAirlineId}
                />
               
              </FormControl>
              {airlineError && <span style={{ color: 'red' }}>{"Valid Airline is required"}</span>}
            </Grid>

            <Grid item md={12} xs={12}>

              {error && <span style={{ color: 'red' }}>{formError}</span>}

              <FormControl
                className={classNames(classes.airlineSelect, classes.formControl)}
              >
                <InputLabel shrink htmlFor="age-label-placeholder">
                  Airports
                </InputLabel>
                <AutocompleteSelect
                    options={airports.map(option => ({value: option.Code, label: option.Name}))}
                    name={"newAirportCode"}
                    handleSelectChange={(e, name) => selectChange(e, name)}
                    disabled={user.AppRole === appConstants.ROLES.AIRPORT_MANAGER }
                    selectedOption={newAirportCode}
                />
               
              </FormControl>
              {airportError && <span style={{ color: 'red' }}>{"Valid Airport is required"}</span>}
            </Grid>

            <Grid item md={12} xs={12}>
              <CustomInput
                style={{ marginTop: "0px" }}
                className={classNames(classes.input, classes.airlineSelect, classes.formControl)}
                required
                labelText="Amount"
                id="newAmount"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={
                  {
                    name: "newAmount",
                    type: "number",
                    onChange: handleChange,
                  }}
              />
              {tokenError && <span style={{ color: 'red' }}>{"Valid Amount is required"}</span>}
            </Grid>


            <Grid item md={12} xs={12}>
              <CustomInput
                className={classes.input}
                required
                labelText="Narration"
                id="narration"
                formControlProps={{
                  fullWidth: true
                }}
                inputProps={
                  {
                    name: "narration",
                    type: "text",
                    onChange: handleChange,
                  }}
              />
              {narrationError && <span style={{ color: 'red' }}>{"Valid Narration is required"}</span>}
            </Grid>

            <Grid item md={12} xs={12}>
              <FormControl className={classes.formControl}>
                <InputLabel shrink htmlFor="reconciliation">Reconciliation Type</InputLabel>
                <AutocompleteSelect
                options={reconciliationTypes.map(option => ({ value: option.value, label: option.name }))}
                // selectedOption={selectedAirline}
                handleSelectChange={(e, name) => selectChange(e, name)}
                // selectLabel={"Airlines"}
                name={"newType"}
                />
                
              </FormControl>
              {typeError && <span style={{ color: 'red' }}>{"Valid Reconciliation Type is required"}</span>}
            </Grid>

            <Grid item md={12} sm={12}>
              <FormControl className={classes.formControl}>
                <InputLabel shrink htmlFor="age-simple">
                  Select Currency
                </InputLabel>
                <AutocompleteSelect
                  options={currencyOptions.map((option) => ({
                    value: option.Id,
                    label: option.Name,
                  }))}
                  selectedOption={currency}
                  handleSelectChange={(e, name) => reactSelectChange(e, name)}
                  name={"currency"}
                />
              </FormControl>
            </Grid>


          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="danger">
            Cancel
                    </Button>
          <Button onClick={handleSubmit} disabled={requesting} color="regional" autoFocus>
            Add
                    </Button>
        </DialogActions>
      </Dialog>

      <Grid container spacing={24}>
        <Grid item lg={3}>
          <div className="picker">
            <InlineDatePicker Date={startDate} handleDateChange={(date) => handleDateChange(date, 'startDate')} label={startLabel} />
          </div>

        </Grid>
        <Grid item lg={3}>
          <div className="picker">
            <InlineDatePicker Date={endDate} handleDateChange={(date) => handleDateChange(date, 'endDate')} label={endLabel} />
          </div>

        </Grid>

        <Grid item lg={3}>
          <FormControl
            className={classNames(classes.airlineSelect, classes.formControl)}
          >
            <InputLabel shrink htmlFor="age-label-placeholder">
              Airlines
            </InputLabel>
            <AutocompleteSelect
            options={data.map(option => ({ value: option.AirlineId, label: option.Airline }))}
            handleSelectChange={(e, name) => selectChange(e, name)}
            disabled={user.AppRole === appConstants.ROLES.AIRLINE}
            name={"AirlineId"}
            selectedOption={AirlineId}
            />
            {/*
            <Select
              disabled={user.AppRole === appConstants.ROLES.AIRLINE}
              value={AirlineId}
              onChange={selectAirlineChange("AirlineId")}
              input={<Input name="airline" id="airline-label-placeholder" />}
              // displayEmpty
              name="AirlineId"
              className={classes.selectEmpty}
            >
              <MenuItem value="-1">All Airlines</MenuItem>
              {data.map((option, i) => (
                <MenuItem
                  key={i}
                  value={option.AirlineId}
                  className={classes.select}
                >
                  {option.Airline}
                </MenuItem>
              ))}
            </Select>
            */}
          </FormControl>
        </Grid>
        <Grid item lg={3}>
          <FormControl
            className={classNames(classes.airlineSelect, classes.formControl)}
          >
            <InputLabel shrink htmlFor="age-label-placeholder">
              Airports
            </InputLabel>
            <AutocompleteSelect
                options={airports.map(option => ({value: option.Code, label: option.Name}))}
                name={"airportCode"}
                handleSelectChange={(e, name) => selectChange(e, name)}
                disabled={user.AppRole === appConstants.ROLES.AIRPORT_MANAGER}
                selectedOption={airportCode}
            />
            {/*
            <Select
              disabled={user.AppRole === appConstants.ROLES.AIRPORT_MANAGER}
              value={airportCode}
              onChange={selectAirlineChange("airportCode")}
              input={<Input name="airport" id="airportCode-label-placeholder" />}
              // displayEmpty
              name="airportCode"
              className={classes.selectEmpty}
            >
              <MenuItem value="-1">All Airports</MenuItem>
              {airports.map((option, i) => (
                <MenuItem
                  key={i}
                  value={option.Code}
                  className={classes.select}
                >
                  {option.Name}
                </MenuItem>
              ))}
            </Select>
            */}
          </FormControl>
        </Grid>
        <Grid item lg={3}>
          <FormControl
            className={classNames(classes.airlineSelect, classes.formControl)}
          >
            <InputLabel shrink htmlFor="age-label-placeholder">
              Status
            </InputLabel>
            <AutocompleteSelect
                options={statusTypes.map(option => ({value: option.value, label: option.name}))}
                name={"Status"}
                handleSelectChange={(e, name) => selectChange(e, name)}
            />
            {/*
            <Select
              value={Status}
              onChange={selectStatusChange("Status")}
              input={<Input name="status" id="airline-label-placeholder" />}
              // displayEmpty
              name="Status"
              className={classes.selectEmpty}
            >
              <MenuItem value="Placeholder">Select Status</MenuItem>
              {statusTypes.map((option, i) => (
                <MenuItem
                  key={i}
                  value={option.value}
                  className={classes.select}
                >
                  {option.name}
                </MenuItem>
              ))}

            </Select>
            */}
          </FormControl>
        </Grid>
        <Grid item lg={3}>
          <FormControl
            className={classNames(classes.airlineSelect, classes.formControl)}
          >
            <InputLabel shrink htmlFor="reconciliation">
              Reconciliation Type
            </InputLabel>
            <AutocompleteSelect
                options={reconciliationTypes.map(option => ({value: option.value, label: option.name}))}
                name={"Type"}
                handleSelectChange={(e, name) => selectChange(e, name)}
            />
            
          </FormControl>
        </Grid>

        <Grid item lg={3}>
          <FormControl
            className={classNames(classes.airlineSelect, classes.formControl)}
          >
            <InputLabel shrink htmlFor="reconciliation">
              Currency
            </InputLabel>
            <AutocompleteSelect
           options={currencyOptions.map((option) => ({
           value: option.Id,
            label: option.Name,
             }))} 
             name={"currency"}
             handleSelectChange={(e, name) => selectChange(e, name)}
            />
            
          </FormControl>
        </Grid>
        <Grid item lg={3}>
          <Button color={"regional"} onClick={() => onSearch()}>Search</Button>
        </Grid>
      </Grid>

    </div>
  );
}

/*ReconciliationPanel.propTypes = {
  classes: PropTypes.object.isRequired,
  airlines: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  selectChange: PropTypes.func.isRequired
};*/

export default withStyles(styles)(ReconciliationPanel);



// WEBPACK FOOTER //
// ./src/Regional-Views/Reconciliation/ReconciliationPanel.jsx